export default __webpack_public_path__ + "static/media/blank.619b154a.jpg";